import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FamilyService } from '../../../backend/api/family.service';
import { BaseComponent } from '../../../core/components/base/base.component';
import { DialogRef } from '../../../core/dialog/dialog-ref';
import { DialogConfig } from '../../../core/dialog/dialog.service';
import { AuthService } from '../../../core/services/auth.service';
import { FamilyRequestDto } from '../../../backend/model/familyRequestDto';
import { CategoryRequestDto, CategoryService } from 'src/app/backend';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  templateUrl: './save-category-dialog.component.html',
  //   styleUrls: ['./save-user-dialog.component.scss'],
})
export class SaveCategoryDialogComponent extends BaseComponent {
  form = new UntypedFormGroup({});
  id = 0;
  isLoading = false;
  isSaving = false;

  constructor(
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef,
    private t: TranslateService,
    private categoryService: CategoryService,
    authService: AuthService,
    messageService: NzMessageService
  ) {
    super(authService, t, messageService);
    const config = this.dialogConfig;
    this.id = config.data?.id;

    this.form = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required]),
      id: new UntypedFormControl(),
    });

    if (this.id) {
      this.loadCategory(this.id);
    }
  }

  loadCategory(id: number) {
    this.isLoading = true;

    this.categoryService.apiCategoryIdGet({ id }).subscribe(
      (res) => {
        this.isLoading = false;
        this.form.patchValue({
          name: res.name,
          id: res.id
        });
      },
      () => {
        this.isLoading = false;
        this.close();
      }
    );
  }

  close(saved?: boolean) {
    this.dialogRef.close({ saved });
  }

  save() {
    if (!this.form.valid) {
      for (const i in this.form.controls) {
        this.form.controls[i].markAsDirty();
        this.form.controls[i].updateValueAndValidity();
      }

      return;
    }
    console.log(this.form.value.documents);
    const data: CategoryRequestDto = {
      name: this.form.value.name,
      id: this.form.value.id,
    };

    const apiCall = this.id
      ? this.categoryService.apiCategoryPut({
          categoryRequestDto: data,
        })
      : this.categoryService.apiCategoryPost({ categoryRequestDto: data });

    this.isSaving = true;

    apiCall.subscribe(
      (res: any) => {
        this.isSaving = false;
        this.close(true);
      },
      (err: HttpErrorResponse) => {
        this.isSaving = false;
        this.errorHandler(err, this.form);
      }
    );
  }
}
